<script lang="ts">
	import type { StoryblokAsset } from '#library/components.schema.build.ts'
	import Image from './image.svelte'
	import { linky } from '#library/linky.ts'

	interface Props {
		link: string
		image?: Partial<StoryblokAsset>
		suptitle?: string
		title: string
		subtitle: string
		caption?: string
		theme?: string
		type?: string
	}

	let { link, image, suptitle, title, subtitle, caption, theme, type }: Props = $props()

	const caption_map = new Map([
		['blog', 'theme-lupton-on-forget-me-not'],
		['news', 'theme-lupton-on-pollen'],
		['gallery', 'theme-lupton-on-lichen'],
		['video', 'theme-lupton-on-pink']
	])

	const href = $derived(linky`${link}`)
</script>

<a class="card {theme || 'theme-rose-on-white'}" {href}>
	<figure class="figure">
		{#if image?.filename}
			<Image src={image.filename} alt={caption} focus={image.focus} width={600} aspect="16/9" fill />
		{:else}
			<div class="fallback">
				<svg class="fallback-icon">
					<use xlink:href="/images/vector.svg#icon"></use>
				</svg>
			</div>
		{/if}
		<figcaption class="caption {caption_map.get(type || 'news')}">{caption}</figcaption>
	</figure>
	<div class="suptitle">{suptitle}</div>
	<div class="title">{title}</div>
	<div class="subtitle">{subtitle}</div>
</a>

<style lang="css">
	.fallback {
		aspect-ratio: 16/9;
		background-color: var(--c-foreground);
		color: var(--c-gimson);
	}

	.fallback-icon {
		inset: 50% auto auto 50%;
		position: absolute;
		rotate: -45deg;
		translate: -50% -50%;
	}

	.card {
		color: var(--c-midground);
	}

	.caption {
		background-color: var(--c-background);
		color: var(--c-foreground);
		font: 500 var(--f-signpost);
		letter-spacing: var(--ls-signpost);
		padding: 0.375rem 1rem;
		text-align: center;
		text-transform: uppercase;
	}

	.suptitle {
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-start: 1rem;
		text-transform: uppercase;

		@media (--from-mobile) {
			margin-block-start: 1.75rem;
		}
	}

	.title {
		font: 600 var(--f-h6);
		letter-spacing: var(--ls-h6);

		@media (--from-mobile) {
			margin-block-start: 0.625rem;
		}
	}

	.subtitle {
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-start: 0.75rem;
	}
</style>
